// Флаг sessionStorage: ставится при авторизации продавца, чтобы модалку о сниженной
// комиссии показать один раз за вход, а не при каждом обновлении страницы
export const FRESH_LOGIN_STORAGE_KEY = 'hs_fresh_login'

// Пин-код блокировки экрана супер-админа. Хранится в открытом виде: это защита от
// посетителя у POS-терминала, а не от того, кто дошёл до devtools
export const SCREEN_LOCK_PIN_KEY = 'hs_screen_lock_pin'
// Признак «экран заблокирован». В localStorage, а не в state, иначе блокировка
// снималась бы обычным F5
export const SCREEN_LOCK_STATE_KEY = 'hs_screen_locked'

// Боковое меню кабинета, общее для всех разделов: 'auto' — свернул раздел, которому
// не хватило места, 'user' — пользователь кнопкой, '0' — раскрыто
export const SIDE_MENU_COLLAPSED_KEY = 'hs_side_menu_collapsed'

// Широкая раскладка кабинета, выбранная кнопкой в шапке. Пока выбора нет, решает ширина окна
export const WIDE_LAYOUT_KEY = 'hs_wide_layout'
